import type { DataGrid, GridFooterRow } from '../types'

function normalizeFooterRow(
  row: GridFooterRow,
  columns: DataGrid['internalData']['visibleColumns']
): GridFooterRow {
  if (!Array.isArray(row)) {
    return row
  }
  const obj: Record<string, unknown> = {}
  columns.forEach((col, i) => {
    if (col.field) {
      obj[col.field] = row[i]
    }
  })
  return obj
}

export function useFooter($grid: DataGrid) {
  $grid.updateFooter = () => {
    const { props, reactData, internalData } = $grid
    const { showFooter, footerData, footerMethod } = props
    let footData: GridFooterRow[] = []
    if (showFooter && footerData?.length) {
      footData = footerData.slice(0)
    } else if (showFooter && footerMethod) {
      const rows = footerMethod({
        $grid,
        columns: internalData.visibleColumns,
        data: reactData.tableData,
      })
      footData = rows.map((row) => normalizeFooterRow(row, internalData.visibleColumns))
    }
    reactData.footerTableData = footData
  }
}
